<template>
  <div>
    <PageName
      :title="isEdit ? 'Редактировать филиала' : 'Создать филиал'"
      :buttons="
        isEdit
          ? [
              {
                text: 'Удалить',
                icon: 'delete',
                event: deleteFiliation,
                iconWidth: '12px',
              },
            ]
          : []
      "
    />
    <Preloader v-if="loading" />
    <Form
        v-if="!loading"
        @request="saveFiliation"
        class="create__filiation"
        v-model="depData"
    >
      <div class="create__filiation-form">
        <VInput
            name="name"
            required
            placeholder="Наименование"
        />
        <VSelect
          name="parent"
          item-text="name"
          placeholder="Родитель"
          :disabled="!isEdit"
          :items="
            isEdit
              ? filiations.filter((fil) => fil.id !== depData.id)
              : filiations
          "
          searchSelect
          filiation
        />
      </div>

      <div>
        <Button
          :loading="saveLoading"
          width="228px"
          height="48px"
          :text="isEdit ? 'Сохранить' : 'Создать'"
          class="btn-primary"
        />
        <Button
          @click.native.prevent="$router.go(-1)"
          width="228px"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          style="margin-top: 12px"
        />
        <Button
          @click.native.prevent="XMLdialog = true"
          width="228px"
          height="48px"
          text="Загрузить с XML"
          class="btn-outline-primary"
          style="margin-top: 32px"
        />
      </div>
    </Form>

    <XMLModal
      v-if="XMLdialog"
      @close="XMLdialog = false"
      url="filiations/import"
    />
  </div>
</template>

<script>
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Button from "@/components/Button.vue";
import PageName from "@/components/PageName.vue";
import XMLModal from "@/components/Modals/XMLModal.vue";
import Preloader from "@/components/Preloader";
import {
  createFiliation,
  updateFiliation,
  deleteFiliation,
  getFiliationById,
} from "@/api/filiations";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  name: "SaveFiliation",
  components: {
    Form,
    VInput,
    VSelect,
    Button,
    PageName,
    XMLModal,
    Preloader
  },
  props: {
    action: String
  },
  data() {
    return {
      saveLoading: false,
      XMLdialog: false,
      depData: {},
      loading: false,
      parent: {},
      id: null
    };
  },
  async mounted() {
    this.id = parseInt(this.$route.params.id_filiation);
    const filiation = this.$route.params.node;

    if (this.isCreate) {
      if (filiation) {
        this.loading = true
        this.depData = {
          parent: {
            name: filiation.name,
            id: filiation.id
          }
        }
        this.loading = false
      }
    } else if (this.isEdit) {
      this.loading = true

      if (this.id) {
        const { data } = await getFiliationById(this.id)
        this.depData = {
          ...data
        }
      }
      this.loading = false
    }
  },
  computed: {
    ...mapState("filiations", ["filiations", "saveFiliationsLoading"]),
    ...mapGetters("filiations", ["getParentFiliationById"]),
    isEdit() {
      return this.action === 'update'
    },
    isCreate() {
      return this.action === 'create'
    },
    getParent() {
      return this.parent
    },
  },
  methods: {
    ...mapMutations("filiations", [
      "ADD_FILIATIONS",
      "DELETE_FILIATIONS",
      "UPDATE_FILIATION",
    ]),
    ...mapActions("filiations", ["getTreeFiliations"]),
    ...mapActions("users", ["getUsers"]),
    saveFiliation: async function (data) {
      this.saveLoading = true;
      const userIds = this.depData.users?.map((user) => user.id);

      try {
        if (this.isEdit) {
          const response = await updateFiliation(
              data.name,
              data.parent?.id,
              userIds,
              data.id
          );

          this.UPDATE_FILIATION(response.data);
        } else {
          const response = await createFiliation(
              data.name,
              data.parent?.id,
              userIds
          );

          data.id = response.data.id;
          this.ADD_FILIATIONS(response.data);
        }
      } catch (err) {
        Promise.reject(err);
      }

      this.getThreeFiliations();
      this.saveLoading = false;
    },
    getThreeFiliations() {
      this.getTreeFiliations().then(() => {
        this.$router.push({ name: "Filiations" });
      });
    },
    deleteFiliation() {
      const deleteFilFunc = () =>
        deleteFiliation(this.depData.id).then(() => {
          this.getThreeFiliations();
          this.DELETE_FILIATIONS(this.depData.id);
          this.$router.push("/admin-panel");
        });

      this.$root.confrim(
        "Вы точно хотите удалить этот филиал?",
        deleteFilFunc,
        "Да"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.create__filiation {
  flex-direction: row;
  gap: 15px;
  margin-top: 32px;

  @media screen and (max-width:1500px){
    margin-top: 24px;
  }

  .create__filiation-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 33px;
    padding: 48px 40px;
    row-gap: 12px;
    background: $light-gray;
    border-radius: 4px;
    width: 100%;

    @media screen and (max-width:1500px){
      padding: 32px 30px;
      column-gap: 18px;
      row-gap: 8px;
    }
  }
}
</style>
